export default {
    '2b-diagram9': {
        'diagram-task': 'Identify the question that the main point raises, and the grouped ideas answer.',
        'checkboxes': {
            'title': 'Question:',
            'checkbox-1': 'How?',
            'checkbox-2': 'Why?',
            'checkbox-3': 'How know?'
        },
        'elements': {
            'one': 'In early phases, memory storage is dynamic and sensitive to disruption',
            'two': 'For a memory to persist, it must be entered into long-term storage',
            'three': 'But first the memory must be stabilized in the brain',
            'four': 'Interrupting the stabilizing process causes the memory to disappear',
        }
    }
}



// WEBPACK FOOTER //
// ./client/app/components/diagrams/2/2b/diagram9/i18n/en.js